document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener('submit', function(event) {
        if (event.target && event.target.matches("form.contact_form")) {
            handleRecallFormSubmit(event);
        }
    });

});

function handleRecallFormSubmit(e) {
    e.preventDefault();

    let formData = new FormData(),
        form = Object.fromEntries(new FormData(e.target))

    Object.keys(form).forEach(function (item) {
        formData.append(item, form[item]);
    });

    formData.append("action", "submit-contact-ajax");
    let params = new URLSearchParams(formData);
    fetch(urls.ajax, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Cache-Control": "no-cache",
        },
        body: params,
    })
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            if (response.success) {
                e.target.parentNode.innerHTML = '<div class="contact__error"><span class="message success">' + response.data.message + '</span></div>';
            } else {
                e.target.parentNode.innerHTML = response.data.form;
            }
        });

}



